import axios from 'axios';
import { API_BASE_URL, AUTH_TOKEN_KEY } from '../../../constants';
import { ISelectedUserSell } from 'interface/reducers/selling';
import { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';

interface IUseFetchUserSellByIdProps {
  id: string;
}

export const useFecthUserSellById = (props: IUseFetchUserSellByIdProps) => {
  const { id } = props;
  const [isFetching, setIsFetching] = useState(false);
  const [data, setData] = useState<ISelectedUserSell>();

  useEffect(() => {
    if (!id) {
      return;
    }

    try {
      axios
        .get(`${API_BASE_URL}/users/sells/${id}`, {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
          },
        })
        .then((response) => {
          const responseData = response.data;
          if (responseData.status_code === 200 && responseData.data) {
            setData(responseData.data);
          }
          setIsFetching(false);
        })
        .catch((err) => {
          console.error('failed to fetch', err);
          setIsFetching(false);
        });
    } catch (err) {
      console.error('fetch user sell by id', err);
      setIsFetching(false);
      setData(undefined);
    }
  }, [id]);

  return {
    isFetching,
    data,
  };
};
